/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowThread200ResponseDataCategory } from './ShowThread200ResponseDataCategory';
import {
    ShowThread200ResponseDataCategoryFromJSON,
    ShowThread200ResponseDataCategoryFromJSONTyped,
    ShowThread200ResponseDataCategoryToJSON,
    ShowThread200ResponseDataCategoryToJSONTyped,
} from './ShowThread200ResponseDataCategory';
import type { ShowThread200ResponseDataPostsInner } from './ShowThread200ResponseDataPostsInner';
import {
    ShowThread200ResponseDataPostsInnerFromJSON,
    ShowThread200ResponseDataPostsInnerFromJSONTyped,
    ShowThread200ResponseDataPostsInnerToJSON,
    ShowThread200ResponseDataPostsInnerToJSONTyped,
} from './ShowThread200ResponseDataPostsInner';
import type { ShowThread200ResponseDataUser } from './ShowThread200ResponseDataUser';
import {
    ShowThread200ResponseDataUserFromJSON,
    ShowThread200ResponseDataUserFromJSONTyped,
    ShowThread200ResponseDataUserToJSON,
    ShowThread200ResponseDataUserToJSONTyped,
} from './ShowThread200ResponseDataUser';

/**
 * 
 * @export
 * @interface ShowThread200ResponseData
 */
export interface ShowThread200ResponseData {
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseData
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseData
     */
    forumCategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseData
     */
    carId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseData
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseData
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseData
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseData
     */
    body?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowThread200ResponseData
     */
    isPinned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowThread200ResponseData
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseData
     */
    lastPostAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseData
     */
    postCount?: number;
    /**
     * 
     * @type {ShowThread200ResponseDataCategory}
     * @memberof ShowThread200ResponseData
     */
    category?: ShowThread200ResponseDataCategory;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseData
     */
    car?: string | null;
    /**
     * 
     * @type {ShowThread200ResponseDataUser}
     * @memberof ShowThread200ResponseData
     */
    user?: ShowThread200ResponseDataUser;
    /**
     * 
     * @type {Array<ShowThread200ResponseDataPostsInner>}
     * @memberof ShowThread200ResponseData
     */
    posts?: Array<ShowThread200ResponseDataPostsInner>;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseData
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseData
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowThread200ResponseData interface.
 */
export function instanceOfShowThread200ResponseData(value: object): value is ShowThread200ResponseData {
    return true;
}

export function ShowThread200ResponseDataFromJSON(json: any): ShowThread200ResponseData {
    return ShowThread200ResponseDataFromJSONTyped(json, false);
}

export function ShowThread200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowThread200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'forumCategoryId': json['forum_category_id'] == null ? undefined : json['forum_category_id'],
        'carId': json['car_id'] == null ? undefined : json['car_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'body': json['body'] == null ? undefined : json['body'],
        'isPinned': json['is_pinned'] == null ? undefined : json['is_pinned'],
        'isLocked': json['is_locked'] == null ? undefined : json['is_locked'],
        'lastPostAt': json['last_post_at'] == null ? undefined : json['last_post_at'],
        'postCount': json['post_count'] == null ? undefined : json['post_count'],
        'category': json['category'] == null ? undefined : ShowThread200ResponseDataCategoryFromJSON(json['category']),
        'car': json['car'] == null ? undefined : json['car'],
        'user': json['user'] == null ? undefined : ShowThread200ResponseDataUserFromJSON(json['user']),
        'posts': json['posts'] == null ? undefined : ((json['posts'] as Array<any>).map(ShowThread200ResponseDataPostsInnerFromJSON)),
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowThread200ResponseDataToJSON(json: any): ShowThread200ResponseData {
    return ShowThread200ResponseDataToJSONTyped(json, false);
}

export function ShowThread200ResponseDataToJSONTyped(value?: ShowThread200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'forum_category_id': value['forumCategoryId'],
        'car_id': value['carId'],
        'user_id': value['userId'],
        'title': value['title'],
        'slug': value['slug'],
        'body': value['body'],
        'is_pinned': value['isPinned'],
        'is_locked': value['isLocked'],
        'last_post_at': value['lastPostAt'],
        'post_count': value['postCount'],
        'category': ShowThread200ResponseDataCategoryToJSON(value['category']),
        'car': value['car'],
        'user': ShowThread200ResponseDataUserToJSON(value['user']),
        'posts': value['posts'] == null ? undefined : ((value['posts'] as Array<any>).map(ShowThread200ResponseDataPostsInnerToJSON)),
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

